import React from 'react';
import Footer from './Footer';
// import ImageSlider from './ImageSlider'
// import Services from './Services'

function Service() {

  return (
<>
<div className="above-sp">
{/* <ImageSlider /> */}
</div>
<div className="container11">

<div className="tut">

  <h1>Comprehensive Digital Solutions</h1>
  <p>The wise man therefore always holds in these matters to this principle of selection.</p>
  

</div>

<div className="com">

  <div className="ui">
  <img className='shad1' src={process.env.PUBLIC_URL+"/Images/icon1.webp"} alt='img' />
                <div className="txt-lt">
      <h2>UI/UX Design</h2>
      <p>Members, Friends Connection ( like followers ), Private Message</p>
    </div>
  </div>


  <div className="ui">
  <img className='shad2'  src={process.env.PUBLIC_URL+"/Images/icon2.webp"} alt='img' />
                <div className="txt-lt">
      <h2>Web Development</h2>
      <p>Your users can create groups to let other users to join and talk</p>
    </div>
  </div>





{/* ////// */}


  <div className="ui">
  <img className='shad3'  src={process.env.PUBLIC_URL+"/Images/icon3.webp"} alt='img' />
                <div className="txt-lt">
      <h2>Mobile Apps Development</h2>
      <p>Forum is ready by BBPress. Your users can make topics and talk.</p>
    </div>
  </div>


  <div className="ui">
  <img className='shad1' src={process.env.PUBLIC_URL+"/Images/icon4.webp"} alt='img' />
                <div className="txt-lt">
      <h2>Game Development</h2>
      <p>You can create Members, Groups It's by drag & drop live builder.</p>
    </div>
  </div>



{/* ////// */}


<div className="ui">
  <img className='shad2' src={process.env.PUBLIC_URL+"/Images/icon5.webp"} alt='img' />
                <div className="txt-lt">
      <h2>Digital Marketing</h2>
      <p>Members, Groups list can be modified by drag & drop live builder.</p>
    </div>
  </div>


  <div className="ui">
  <img className='shad3' src={process.env.PUBLIC_URL+"/Images/icon6.webp"} alt='img' />
                <div className="txt-lt">
      <h2>AR/VR Development</h2>
      <p>8 different scroll effects are ready. You can always change by your tastes.</p>
    </div>
  </div>

{/* ////// */}


  <div className="ui">
  <img className='shad1' src={process.env.PUBLIC_URL+"/Images/icon7.webp"} alt='img' />
                <div className="txt-lt">
      <h2>Testing</h2>
      <p>We ensure bug-free, high-performance apps through expert testing.</p>
    </div>
  </div>


  <div className="ui">
  <img className='shad3' src={process.env.PUBLIC_URL+"/Images/icon8.webp"} alt='img' />
                <div className="txt-lt">
      <h2>Devops</h2>
      <p>We streamline deployment and scaling with efficient, automated DevOps solutions.</p>
    </div>
  </div>



{/* ////// */}


<div className="ui">
  <img className='shad2' src={process.env.PUBLIC_URL+"/Images/icon9.webp"} alt='img' />
                <div className="txt-lt">
      <h2>Application maintenance</h2>
      <p>Reliable application maintenance for performance, security, and updates.</p>
    </div>
  </div>


  <div className="ui">
  <img className='shad3' src={process.env.PUBLIC_URL+"/Images/icon10.webp"} alt='img' />
                <div className="txt-lt">
      <h2>Support 24/7</h2>
      <p>24/7 support ensuring continuous uptime, stability, and assistance.</p>
    </div>
  </div>

{/* //// */}
    </div>

  </div><br></br><br></br><br></br>
      <Footer/>
 </>

  )
}

export default Service;
